var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BButton', _vm._b({
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: _vm.hoverPopupText,
      expression: "hoverPopupText",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "omnistock omni-btn",
    class: _vm.computedClassNames,
    attrs: {
      "disabled": _vm.disabled,
      "variant": _vm.variant
    },
    on: {
      "click": _vm.onClick
    }
  }, 'BButton', [_vm.$attrs, _vm.$props], false), [_vm.iconOnly && _vm.hasIcon ? [_vm._t("icon", function () {
    return [!_vm.isProcessing ? _c('FontAwesomeIcon', {
      attrs: {
        "icon": _vm.icon,
        "spin": _vm.iconSpin
      }
    }) : _c('FontAwesomeIcon', {
      attrs: {
        "icon": "spinner",
        "spin": ""
      }
    })];
  })] : [_vm._t("default"), _vm.isProcessing ? _c('FontAwesomeIcon', {
    staticClass: "d-inline-block ml-2",
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _vm._e()]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }